export enum ModalSize {
    Default = 'default',
    Small = 'sm',
    Medium = 'md',
    Large = 'lg',
    XLarge = 'xl'
}
